import React from "react";
import ServiceDetailPage from "./ServiceDetailPage";

export default function GeneralOrderSupply() {
  return (
    <ServiceDetailPage
      pageClassName="gos"
      heroClassName="gos-hero"
      title="General Order Supply"
      subtitle="Reliable sourcing and delivery of quality equipment, tools, and materials—on time and on budget."
      heroPrimaryLabel="Explore Overview"
      heroSecondaryLabel="Request a Quote"
      overviewLead="We manage end‑to‑end procurement—from vendor selection and quality assurance to logistics and after‑sales support."
      overviewBullets={[
        "Multi‑vendor sourcing with competitive pricing",
        "Category coverage across IT, industrial, and MRO",
        "Quality control, documentation, and compliance",
        "On‑time deliveries with transparent tracking",
        "Warranty coordination and after‑sales service",
      ]}
      features={[
        { title: "Vendor Network", description: "Diverse, vetted suppliers for reliable fulfillment." },
        { title: "Quality Assurance", description: "Inspection protocols and documentation on delivery." },
        { title: "Category Coverage", description: "IT hardware, safety/PPE, industrial tools, and more." },
        { title: "Logistics & Tracking", description: "ETAs, milestones, and proof‑of‑delivery controls." },
        { title: "Stock Management", description: "Buffer stock and call‑off orders for repeat needs." },
        { title: "After‑Sales Support", description: "Warranty handling and replacement coordination." },
      ]}
      solutionsHeading="Supply Programs"
      solutions={[
        {
          title: "Industrial Supplies",
          description: "Tools, fittings, consumables, and site materials.",
          items: ["Approved brand catalogs", "Batch and lot tracking", "Bulk procurement"],
        },
        {
          title: "IT Equipment",
          description: "Laptops, servers, networking, and accessories.",
          items: ["Configuration to spec", "Warranty coordination", "Asset tagging"],
        },
        {
          title: "Safety & PPE",
          description: "Standards‑compliant safety gear for field teams.",
          items: ["Size ranges and fit checks", "Compliance certificates", "Replenishment schedules"],
        },
        {
          title: "Office & MRO",
          description: "Stationery, janitorial, and maintenance supplies.",
          items: ["Framework agreements", "Call‑off ordering", "Monthly consolidation"],
        },
      ]}
      pricingLead="Flexible models for one‑off orders, contracts, or strategic sourcing."
      pricingTiers={[
        {
          title: "Standard Procurement",
          description: "Per‑order sourcing and delivery.",
          items: ["Competitive quotes", "Quality checks", "Delivery tracking"],
        },
        {
          title: "Contract Supply",
          description: "Monthly or Quarterly replenishment plans.",
          items: ["Price Locks & SLAs", "Buffer stock", "Consolidated billing"],
          featured: true,
        },
        {
          title: "Strategic Sourcing",
          description: "Category management and vendor optimization.",
          items: ["Framework agreements", "Compliance & reporting", "Dedicated buyer desk"],
        },
      ]}
      contactTitle="Talk to Our Supply Team"
      contactLead="Send your item list or BOQ—we’ll respond with pricing and timelines."
    />
  );
}